import React from "react";
import { connect } from "react-redux";
import {
  callAuthGetSkipInfo,
  callSaveSkipDenialReasons,
  callAuthRefinanceRedirect,
} from "../../../../actions/authPayment.actions";
import { PrincipalOnlyPopupButton } from "./popup-menu-buttons/principal-only-popup-button.component";
import { PayoffLetterPopupButton } from "./popup-menu-buttons/payoff-letter-popup-button.component";
import { PayoffLoanPopupButton } from "./popup-menu-buttons/payoff-loan-popup-button.component";
import { LoanDetailsPopupButton } from "./popup-menu-buttons/loan-details-popup-button.component";
import { SkipAPayPopupButton } from "./popup-menu-buttons/skip-a-pay-popup-button.component";
import { RefinancePopupButton } from "./popup-menu-buttons/refinance-popup-button.component";

const AuthCardPopupMenuComponent = (props) => {
  return (
    <div className="row px-2 pt-1" style={{ position: "relative" }}>
      <button
        className="ml-auto mt-0 p-0 px-2"
        style={{ backgroundColor: "white" }}
        onClick={props.togglePopupMenu}
        data-e2e-id={"loanMenuButton-" + props.lastFour}
      >
        <div className="d-flex">
          <i class="material-icons">more_horiz</i>
        </div>
      </button>
      <div
        className="auth-card-popup-menu"
        style={{
          display: props.showPopupMenu ? "" : "none",
        }}
      >
        <ul className="p-0 m-0" style={{ listStyleType: "none" }}>
          <SkipAPayPopupButton {...props} />
          <RefinancePopupButton {...props} />
          <PayoffLetterPopupButton {...props} />
          <PayoffLoanPopupButton {...props} />
          <PrincipalOnlyPopupButton {...props} />
          <LoanDetailsPopupButton {...props} />
        </ul>
      </div>
    </div>
  );
};
const mapDispatchToProps = {
  callAuthGetSkipInfo,
  callSaveSkipDenialReasons,
  callAuthRefinanceRedirect,
};

const mapStateToProps = null;

export const AuthCardPopupMenu = connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthCardPopupMenuComponent);



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/loan-list/card-children/auth-card-popup-menu.component.js